"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[4130,8708],{

/***/ 4130:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Drawer)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _swiper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8708);
// components/drawer.js



function Drawer({ wrapper }) {
  const selectors = {
    drawerTrigger: '.js-drawer-trigger',
    drawerClose: '.js-drawer-close',
    drawer: '.js-drawer',
    overlay: '.js-drawer-overlay',
    productForm: 'form[action="/cart/add"]',
  }

  const drawerId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawer).attr('id')

  const cache = {
    $drawerTrigger: jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find(selectors.drawerTrigger).filter(`[data-drawer="${drawerId}"]`),
    $drawerClose: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawerClose),
    $drawer: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawer),
    $overlay: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.overlay),
    $productForm: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.productForm),
  }

  ;(function init() {
    const { $drawerTrigger, $drawer } = cache

    if (!$drawerTrigger.length) return

    initializeEventListeners()
  })()

  function initializeEventListeners() {
    const { $drawerTrigger, $drawerClose, $productForm } = cache

    $drawerTrigger.on('click', toggleDrawer)
    $drawerClose.on('click', closeDrawer)
    $productForm.on('submit', closeDrawer)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', listenForEscape)
    
      // Close drawer when clicking on navigation elements (the drawer trigger handles its own toggle)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', 'nav button, .js-sub-nav button, a[href="/cart"]', function(e) {
        if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass('js-drawer-trigger')) {
          closeDrawer(e)
        }
      })
  
  }

  function toggleDrawer(e) {
    e.stopPropagation()
    const { $drawer } = cache
    // If drawer is already open (has 'active' class), close it; otherwise open it
    if ($drawer.hasClass('active')) {
      closeDrawer(e)
    } else {
      openDrawer.call(this, e)
    }
  }

  function listenForEscape(e) {
    if (e.keyCode === 27) {
      closeDrawer(e)
    }
  }

  function openDrawer(e) {
    e.preventDefault()
    e.stopPropagation()
    const { $drawer, $overlay } = cache

    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let targetDrawer = $this.data('drawer')

    
    if ($drawer.data('drawer') == targetDrawer) {
      $this.addClass('active')
      // Remove hidden class and show drawer to trigger transition
      $drawer.removeClass('tw-hidden')
      if ($drawer.hasClass('wishlist-drawer')) {
        // For wishlist drawers, use Tailwind transform transition
        $drawer.css('display', 'flex')
        // Force reflow to ensure transition works
        $drawer[0].offsetHeight
        // Remove translate-x-full to slide in
        $drawer.removeClass('tw-translate-x-full')
        setTimeout(function() {
          $drawer.addClass('active')
        }, 10)
      } else {
        if ($drawer.hasClass('tw-flex')) {
          $drawer.css('display', 'flex')
        } else {
          $drawer.show()
        }
        $drawer.addClass('active')
      }

      setTimeout(function () {
        $overlay.removeClass('tw-hidden').fadeIn(150)

        // Initialize sliders inside the drawer content with a small delay to ensure rendering
        setTimeout(function () {
          const sliders = $drawer.find('[data-slick]')

          sliders.each(function () {
            const $slider = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)

            // If slick is already initialized, refresh it
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('refresh')
              $slider.slick('slickGoTo', 0, false)
            } else {
              // Otherwise initialize it
              new _swiper_js__WEBPACK_IMPORTED_MODULE_1__["default"](this).init()
            }
          })
        }, 50)
      }, 10)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
    }
  }

  function closeDrawer(e) {
    e.preventDefault()
    const { $drawerTrigger, $drawer, $overlay } = cache

    $drawerTrigger.removeClass('active')
    $overlay.fadeOut(150)
    
    // Remove active class and add translate-x-full to trigger slide-out transition
    $drawer.removeClass('active')
    if ($drawer.hasClass('wishlist-drawer')) {
      $drawer.addClass('tw-translate-x-full')
    }
    
    // Wait for transition to complete before hiding
    setTimeout(function () {
      $drawer.addClass('tw-hidden').css('display', 'none')
      $overlay.addClass('tw-hidden')
    }, 400)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }
}

/***/ }),

/***/ 8708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Slider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4128);
/* harmony import */ var _on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2192);




function Slider({ wrapper }) {
  
  const { classes } = window.config;

  const defaultSettings = {
    centeredSlidesBounds: true,
    cssMode: true,
    slidesPerView: 'auto',
    breakpoints: {
      768: {
        centeredSlidesBounds: true,
        cssMode: false,
        grabCursor: true,
      },
    },
  }

  let settings = null,
    swiper = null

  ;(function init() {
    buildSettings()

    swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(wrapper, settings)

    // Add active class to button if autoplay is enabled by default
    if (swiper.autoplay && swiper.autoplay.running) {
      const $toggleButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook="toggle-playback"]')
      if ($toggleButton.length > 0) {
        $toggleButton.addClass(classes.active)
      }
    }

    initEventListeners()
    autoDisable()

    if (getBreakpointsWithDisabled().length) {
      listenForDisable()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', listenForDisable)
    }
  })()

  function buildSettings() {
    // Use the default config if one isn't provided
    settings = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') : defaultSettings

    // Set "cssMode" to "auto" by default
    if (typeof settings.cssMode === 'undefined' || settings.cssMode === 'auto') {
      settings.cssMode = (0,_on_sight_strategy_os_utilities__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq)()
    }
  }

  function getBreakpointsWithDisabled() {
    if (settings.breakpoints) {
      return Object.keys(settings.breakpoints).filter((breakpoint) => {
        return settings.breakpoints[breakpoint].disable
      })
    } else {
      return []
    }
  }

  function breakpointMatches(breakpoint) {
    return window.matchMedia(`(min-width: ${breakpoint}px)`)
  }

  function listenForDisable() {
    const breakpoints = getBreakpointsWithDisabled()

    if (breakpoints.length) {
      breakpoints.forEach(function (breakpoint) {
        const breakpointMatch = breakpointMatches(breakpoint)

        if (breakpointMatch.matches) {
          swiper.destroy(false)
        } else if (swiper.destroyed) {
          swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(wrapper, settings)
        }
      })
    }
  }

  function initEventListeners() {
    
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('swiper:requestInstance', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('swiper:recieveInstance', [swiper])
    })
    
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', '[data-hook="toggle-playback"]', togglePlayback)

    swiper.on('resize', autoDisable)
  }

  function autoDisable() {
    const slidesOverflow = jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).innerWidth() < swiper.virtualSize

    if (swiper.passedParams.autoDisable != false && !swiper.params.loop && !slidesOverflow) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).removeClass(classes.active)

      // @jake - how to prefix these classes ? should they be added to the window.config.classes object?
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.wrapperEl).addClass('!transform-none >:!shrink').css({
        transform: '',
        width: 'fit-content',
        marginInline: 'auto',
      })

      swiper.disable()
      swiper.update()
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).addClass(classes.active)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.wrapperEl).removeClass('!transform-none >:!shrink')

      swiper.enable()
      swiper.update()
    }
  }

  function togglePlayback(e) {
    
    // Check if autoplay is currently running
    const isAutoplayRunning = swiper.autoplay && swiper.autoplay.running
    
    if (isAutoplayRunning) {
      swiper.autoplay.stop()
      // Remove active class from button to show play icon
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass(classes.active)
    } else {
      swiper.autoplay.start()
      // Add active class to button to show pause icon
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass(classes.active)
    }
  }

  return swiper
}


/***/ }),

/***/ 2192:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ds: () => (/* binding */ debounce),
/* harmony export */   Sl: () => (/* binding */ elementsExist),
/* harmony export */   a9: () => (/* binding */ toggleScroll),
/* harmony export */   am: () => (/* binding */ getElementMostVisible),
/* harmony export */   lb: () => (/* binding */ formatMoney),
/* harmony export */   sZ: () => (/* binding */ syncElementsHeight),
/* harmony export */   tq: () => (/* binding */ isMobile)
/* harmony export */ });
/* unused harmony export calculatePixelsOnScreen */
/**
 * * Checks if the given elements exist on the DOM
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */
function elementsExist(elements = []) {
  return elements.filter((el) => el.length).length == elements.length
}

/**
 * * Applies scroll locked styles to the docuemnt body
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */
function toggleScroll({ lock, yPosition }) {
  const body = document.body

  // Check if the scroll should be locked or unlocked
  const lockScroll = lock != null ? lock == true : body.style.overflow != 'hidden'

  if (lockScroll) {
    // Lock the scroll
    let scrollPosition = window.pageYOffset
    if (yPosition != null) scrollPosition = yPosition

    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.top = `-${scrollPosition}px`
    body.style.width = '100%'
  } else {
    // Unlock the scroll
    const scrollPosition = parseInt(body.style.top) * -1

    body.style.removeProperty('overflow')
    body.style.removeProperty('position')
    body.style.removeProperty('top')
    body.style.removeProperty('width')

    window.scrollTo({ top: scrollPosition, behavior: 'instant' })
  }
}

/**
 * * Determines if the current screen is mobile-sized
 *
 * @returns {boolean} Whether the current screen width is within the mobile threshhold
 */
function isMobile() {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    return true
  }

  return false
}

/**
 *
 * @param {*} cents
 * @param {*} format
 * @returns
 */
function formatMoney(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '')

  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || '${{ amount_no_decimals }}'

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

/**
 * Updates a list of elements to all match the height of the tallest element provided
 *
 * @param {jQuery node list} $elements
 */
function syncElementsHeight($elements) {
  if (!$elements.length) return

  // Reset heights to get accurate measurement
  $elements.height('auto')

  // Sort elements by intrinsic height
  const sortedByHeight = $elements.sort((a, b) => {
    return b.offsetHeight - a.offsetHeight
  })
  const maxHeight = sortedByHeight[0].offsetHeight

  // Set all elements to match the tallest element found
  $elements.height(maxHeight)
}

// Get the number of pixels an element is on screen
function calculatePixelsOnScreen(element) {
  // Make sure we have a jQuery object

  if (!element instanceof HTMLElement) return;

  // Get the element height, top, and bottom
  const top = element.offsetTop;
  const height = element.offsetHeight;
  const elementBottom = top + height;

  // Get the viewport top and bottom
  const viewportTop = window.scrollY
  const viewportBottom = viewportTop + window.innerHeight

  // Calculate the number of pixels above and below the screen
  const pixelsAboveScreen = Math.max(viewportTop - top, 0)
  const pixelsBelowScreen = Math.max(elementBottom - viewportBottom, 0)
  const pixelsRemaining = Math.max(height - pixelsAboveScreen - pixelsBelowScreen, 0)

  // Return the remaining number of pixels on screen
  return pixelsRemaining;
}

// Get the element that is taking up the most visible space on screen
function getElementMostVisible($elements) {
  const elementsArray = $elements.toArray()

  const elementMostVisible = elementsArray.reduce((elementA, elementB) => {
    // Compare the number of pixels on screen for each element in the array
    const pixelsOnScreenA = calculatePixelsOnScreen(elementA)
    const pixelsOnScreenB = calculatePixelsOnScreen(elementB)

    // Return the element with the most pixels on screen
    if (pixelsOnScreenB > pixelsOnScreenA) return elementB
    return elementA
  }, $elements[0])

  return elementMostVisible
}

function debounce(callback, wait = 200) {
  let timeoutId = null

  return (...args) => {
    window.clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      callback.apply(this, args)
    }, wait)
  }
}

/***/ })

}]);